import { Component, Prop, Vue } from 'vue-property-decorator';
import { randomIdentifier } from '@/helpers/StringHelpers';
import RadioItems from '@/components/forms/RadioItems.vue';
import RequiredAsterisk from '@/components/forms/RequiredAsterisk.vue';
@Component({
    name: 'RadioGroup',
    components: { RadioItems, RequiredAsterisk },
})
export default class default_1 extends Vue {
    @Prop({ required: true })
    options;
    @Prop()
    label;
    // Initial value property.
    @Prop({ default: null })
    value;
    @Prop({ default: false })
    optional;
    @Prop({ default: false })
    hideAsterisk;
    @Prop()
    error;
    @Prop()
    itemClassName;
    @Prop()
    disabled;
    @Prop()
    showMoreLabel;
    errorInternal = null;
    labelId = 'radio-group-label-' + randomIdentifier();
    created() {
        this.errorInternal = this.error || null;
        if (this.options.length === 1 && !this.optional) {
            this.$emit('input', this.options[0].value);
        }
    }
    onInput(value, event) {
        this.$emit('input', value, event.target);
        this.validate();
    }
    validate() {
        const radioGroup = this.$refs.radioGroup;
        const invalidField = radioGroup.$el.querySelector(':invalid');
        this.errorInternal = invalidField ? invalidField.validationMessage : null;
    }
    get showAsterisk() {
        return !this.optional && !this.hideAsterisk && !this.disabled;
    }
}
